import { store } from '../store/store'
import ConfigurationService from '../components/configuration/configuration.service'
import orchestration from '../orchestration'
import { CONSTANT, SDK_METHODS } from '../utils/constant'
import encrypt from './encrypt'

const crypto = require('crypto')

const configurationService = new ConfigurationService()
const sharedService = {

  /**
   * @param environmentId
   * @returns {Promise<void>}
   */
  async loadSrcKeys (environmentId) {
    try {
      let response = await configurationService.getSrcKeys(environmentId)
      if (response) {
        await store.dispatch('updateKeysByEnv', response)
      }
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Validate New card before checkout
   * @param cardDetails
   * @returns {boolean}
   */
  validateCardDetails ({ cardNumber, expiryMonth, expiryYear, cvv, cardNetwork }) {
    if (!cardNumber || (cardNumber.length > 0 && cardNumber.length < 15) || !cardNetwork) {
      return false
    } else if (this.validateExpiryDate(expiryMonth, expiryYear)) {
      return false
    } else if (this.validateCVV(cvv)) {
      return false
    } else {
      return true
    }
  },

  /**
   * validate expiry date
   */
  validateExpiryDate (expiryMonth, expiryYear) {
    if (expiryMonth.length !== 2 || expiryMonth > 12 || expiryMonth === '00') {
      return true
    } else if (expiryYear.length !== 4 || expiryYear === '0000') {
      return true
    } else {
      let todayDate = new Date()
      let currentMonth = (todayDate.getMonth() + 1)
      let currentYear = todayDate.getFullYear().toString()
      expiryMonth = parseInt(expiryMonth, 10)
      if (expiryYear < currentYear) {
        return true
      } else if (expiryYear === currentYear && expiryMonth < currentMonth) {
        return true
      } else {
        return false
      }
    }
  },

  /**
   * validate cvv
   * @param cvv
   * @returns {boolean}
   */
  validateCVV (cvv = '') {
    if (!cvv || (cvv.length < 3 || cvv.length > 4)) {
      return true
    } else {
      return false
    }
  },

  intializeSdk (dpaTransactionOptions) {
    return new Promise(resolve => {
      orchestration.callMethod({
        methodName: SDK_METHODS.INIT,
        methodParameters: { dpaTransactionOptions }
      }).then(() => {
        resolve()
      })
    })
  },

  isRecognized () {
    return new Promise(resolve => {
      orchestration.callMethod({ methodName: SDK_METHODS.ISRECOGNIZED }).then(isRecognizedResponse => {
        store.commit('recognized', isRecognizedResponse)
        resolve()
      })
    })
  },

  getDpaTransactionOptions () {
    return {
      transactionAmount: {
        transactionAmount: 100,
        transactionCurrencyCode: 'USD'
      },
      transactionType: 'PURCHASE',
      dpaLocale: store.getters.dpaLocale,
      paymentOptions: {
        dpaDynamicDataTtlMinutes: 15,
        dynamicDataType: store.getters.cryptoType
      }
    }
  },

  checkoutWithNewCard (encryptedCard) {
    let dpaTransactionOptions = this.getDpaTransactionOptions()
    let methodParameters = { encryptedCard, dpaTransactionOptions }
    if (store.getters.recognizedIdToken) {
      methodParameters.idToken = store.getters.recognizedIdToken
    }
    return new Promise(resolve => {
      orchestration.callMethod({
        methodName: SDK_METHODS.CHECKOUT,
        methodParameters
      }).then(response => {
        store.commit('loaderOn', false)
        resolve(response)
      })
    })
  },

  checkoutWithCard (cardDetials) {
    let dpaTransactionOptions = this.getDpaTransactionOptions()
    let methodParameters = { dpaTransactionOptions }
    methodParameters.idToken = cardDetials.idToken
    methodParameters.srcCorrelationId = cardDetials.srcCorrelationId
    methodParameters.srcDigitalCardId = cardDetials.srcDigitalCardId

    return new Promise(resolve => {
      orchestration.callMethod({
        methodName: SDK_METHODS.CHECKOUT,
        methodParameters
      }).then(response => {
        store.commit('loaderOn', false)
        resolve(response)
      })
    })
  },

  async callSignatureApi (request, apiName) {
    let requestUrl = apiName === 'payload' ? store.getters.payloadRequestUrl : store.getters.confirmationRequestUrl
    let requestBody = {
      consumerKey: store.getters.srcConsumerKey,
      requestUrl: requestUrl,
      requestBody: JSON.stringify(request)
    }

    let response = await configurationService.getSignatureHeader(requestBody)
    return Promise.resolve(response)
  },

  async callPayB2BApi (maSdkAuthSignResponse, request, apiName) {
    const { signatureBaseString, nonce, timestamp } = maSdkAuthSignResponse
    let requestUrl = apiName === 'payload' ? store.getters.payloadRequestUrl : store.getters.confirmationRequestUrl
    const signingKey = store.getters.pemKey
    let requestBody = {
      consumerKey: store.getters.srcConsumerKey,
      requestUrl: requestUrl,
      signature: this.getSignature(signatureBaseString, signingKey),
      nonce: nonce,
      timestamp: timestamp,
      requestBody: JSON.stringify(request)
    }
    let response = apiName === 'payload' ? await configurationService.getCheckoutResponseJWS(requestBody) : await configurationService.getConfirmationApiResponse(requestBody)
    return Promise.resolve(response)
  },

  getSignature (sbs, signingKey) {
    let signer = crypto.createSign('RSA-SHA256')
    signer = signer.update(Buffer.from(sbs))
    let signature
    try {
      signature = signer.sign(signingKey, 'base64')
    } catch (e) {
      throw new TypeError('Unable to sign the signature base string.')
    }
    return signature
  },

  deleteCard (cardDetails) {
    let methodParameters = { 'srcDigitalCardId': cardDetails }
    return new Promise(resolve => {
      orchestration.callMethod({
        methodName: SDK_METHODS.DELETE_CARD,
        methodParameters
      }).then(response => {
        store.commit('loaderOn', false)
        resolve()
      })
    })
  },

  verifyEmailId (emailId) {
    // eslint-disable-next-line
    let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
    if (regex.test(emailId)) {
      return true
    } else {
      return false
    }
  },

  /**
   * Unmask the value passed
   * @param val
   * @returns {*}
   */
  unmask (val) {
    if (val) {
      return val.replace(/\D+/g, '')
    }
  },

  async encryptCard ({ cardDetail }) {
    let srcNetwork = (cardDetail.network || 'mastercard').toUpperCase()
    let srcNetworkKeys = store.getters.srcKeys[srcNetwork].keys
    const encParam = {
      encContentAlgo: CONSTANT.PAN_ENC[srcNetwork].ENCRYPTION_CONTENT_ALGO,
      encAlgo: CONSTANT.PAN_ENC[srcNetwork].ENC_ALGO,
      encKeyId: store.getters.cardEncKey,
      keys: srcNetworkKeys
    }
    delete cardDetail.network
    console.log('Card detail getting passed in encryption', cardDetail, encParam)
    return encrypt.encryptCard(cardDetail, encParam)
  },

  /**
   * load src config when changes in env
   * @param env
   * @returns {Promise<void>}
   */
  async loadSrcConfiguration (env) {
    try {
      await this.updateSrcConfig(env)
    } catch (error) {
      console.error(error)
      this.updateSrcEntityIds([])
      this.updateDpaIds([])
    }
  },

  /**
   * Load API EndPoint
   * @param environmentId
   * @returns {Promise<void>}
   */
  async loadApiEndPoint (environmentId) {
    try {
      let response = await configurationService.getApiEndPoints(environmentId)
      return Promise.resolve(response)
    } catch (error) {
      console.log(error)
    }
  }
}
export default sharedService
